import { ReactElement, useState } from "react";
import { BsCameraVideo } from "react-icons/bs";
import {
  IoArchiveOutline,
  IoImageOutline,
  IoLocationOutline,
} from "react-icons/io5";
import chatSidebarTime from "../../../utils/chatSidebarTime";
import { OuterChat } from "../../../types/ChatListType";
import { HiOutlineDocumentText } from "react-icons/hi";

import {
  ContextMenu,
  ContextMenuTrigger,
  ContextMenuItem,
} from "rctx-contextmenu";
import { socketInstance } from "../../../socket/socket";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import LoadingSkeletonImageDynamic from "../../../components/LoadingSkeletonImageDynamic";
import { BlockUserRes } from "../../../types/ResType";
import useApiPost from "../../../hooks/PostData";
import toast from "react-hot-toast";
import CallInConversationList from "./CallInConversationList";
import { RiContactsLine } from "react-icons/ri";
import TextTranslate from "../../../utils/TextTranslate";
import TypingIndicator from "../../../components/TypingIndicator";
import ChatListLastMessagePreview from "../../../components/ChatListLastMessagePreview";
import { updateMessageOptions } from "../../../store/Slices/MessageOptionsSlice";
import { useNavigateToChat } from "../../../hooks/useNavigateToChat";
import { useTranslateText } from "../../../hooks/useTranslateText";
import { useTimeFormatOptions } from "../../../hooks/useTimeFormatOptions";
import SearchNotFoundAnimation from "../../../components/SearchNotFoundAnimation";
import { LuTrash2 } from "react-icons/lu";
import { MdOutlineBlock } from "react-icons/md";

export default function ArchiveConversationList({
  searchUser,
}: {
  searchUser: string;
}) {
  const { postData } = useApiPost();
  // useEffect(() => {
  //   socketInstance().emit("archived_chat_list", {});
  // }, []);
  const dispatch = useAppDispatch();
  const translate = useTranslateText();
  const { translate: translateTime, hour12 } = useTimeFormatOptions();
  const OnlineUserList = useAppSelector((state) => state.OnlineUserList);
  const TypingUserList = useAppSelector((state) => state.TypingUserList);
  const archiveList = useAppSelector((state) => state.archiveList);
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );

  const user_id = useAppSelector((state) => state.userData.user_id);

  const navigateToChat = useNavigateToChat();
  const [SelectedConversation, setSelectedConversation] = useState<OuterChat>();

  async function blockUser() {
    const is_block = SelectedConversation?.Records[0].blocked_by.includes(
      user_id.toString(),
    );
    dispatch(
      updateMessageOptions({
        showModal: true,
        modalName: "block_user",
        title: `Are you sure you want to ${is_block ? "unblock" : "block"} ${SelectedConversation?.PeerUserData.full_name}`,
        description: is_block
          ? "After unblocking, you will receive messages from this user."
          : "After blocking, you will not receive any messages from this user.",
      }),
    );
  }

  async function unArchiveConversation() {
    socketInstance().emit("archive_chat", {
      chat_id: SelectedConversation?.Records[0].chat_id,
    });
    // socketInstance().emit("ChatList", {});
    toast.success(translate("Conversation Unarchived"), { position: "bottom-left" });
  }

  async function deleteConversation() {
    const chat = SelectedConversation;
    if (!chat?.Records?.[0]) return;
    sessionStorage.setItem("selectedConversation", JSON.stringify(chat));
    const name =
      chat.Records[0].chat_type == "group"
        ? chat.Records[0].group_name
        : chat.PeerUserData.full_name;
    dispatch(
      updateMessageOptions({
        showModal: true,
        modalName: "delete_conversation",
        title: `Are you sure you want to delete this chat with ${name}?`,
        description:
          "The conversation will be removed from your chat list. This action cannot be undone.",
      }),
    );
  }

  const chatMenuItemClass =
    "hover:!bg-dropdownOptionHover !rounded-lg !px-4 !py-1.5 !flex !items-center !justify-between !gap-2 !text-sm !text-darkText";

  return (
    <>
      <div className="flex w-full flex-col overflow-x-hidden pb-16 lg:pb-0">
        {archiveList.Chats.length == 0 ? (
          <div className="grid h-96 place-content-center gap-5">
            <SearchNotFoundAnimation />
            <div>{translate("No Conversations Found")}</div>
          </div>
        ) : (
          archiveList.Chats.filter(
            (chat) =>
              chat.PeerUserData.full_name
                .toLowerCase()
                .includes(searchUser.toLowerCase()) ||
              chat.Records[0].group_name
                .toLowerCase()
                .includes(searchUser.toLowerCase()),
          ).map((e) => {
            return (
              <>
                <ContextMenuTrigger
                  id="my-context-menu-2"
                  className="block w-full"
                >
                  <div
                    onClick={() => {
                      navigateToChat({
                        chat_id: e.Records[0].chat_id,
                        chat_type: e.Records[0].chat_type,
                        full_name: e.PeerUserData.full_name,
                        group_name: e.Records[0].group_name,
                        group_icon: e.Records[0].group_icon,
                        profile_pic: e.PeerUserData.profile_pic,
                        blur_hash:
                          e.Records[0].chat_type == "group"
                            ? e.Records[0].blur_hash ||
                              e.Records[0].blurHash ||
                              ""
                            : e.PeerUserData.blur_hash ||
                              e.PeerUserData.blurHash ||
                              "",
                        user_id: e.PeerUserData.user_id,
                        is_group_blocked: e.Records[0].blocked_by.includes(
                          user_id.toString(),
                        ),
                        user_name: e.PeerUserData.user_name,
                        email_id: e.PeerUserData.email,
                        unseen_count: e.Records[0].unseen_count,
                        updatedAt: e.PeerUserData.updatedAt!,
                        is_message_list_empty:
                          e.Records[0].Messages.length === 0,
                        createdAt: e.Records[0].createdAt,
                        bio: e.PeerUserData.bio,
                        group_description: e.Records[0].group_description,
                        mobile_num: e.PeerUserData.mobile_num!,
                        is_archived: true,
                      });
                    }}
                    onContextMenu={() => {
                      setSelectedConversation(e);
                    }}
                    className={`group flex w-full cursor-pointer items-center gap-3 px-4 py-3 transition active:bg-black/[0.03] hover:bg-selectedChat dark:active:bg-white/[0.04] ${currentConversationData.chat_id == e.Records[0].chat_id ? "bg-selectedChat" : ""}`}
                  >
                    <div className="relative h-14 w-14 shrink-0">
                      <LoadingSkeletonImageDynamic
                        radius=""
                        className="h-14 w-14 rounded-full object-cover ring-1 ring-black/5 dark:ring-white/10"
                        image_height="100%"
                        image_url={
                          e.Records[0].chat_type == "group"
                            ? e.Records[0].group_icon
                            : e.PeerUserData.profile_pic
                        }
                        blur_hash={
                          e.Records[0].chat_type == "group"
                            ? e.Records[0].blur_hash || e.Records[0].blurHash
                            : e.PeerUserData.blur_hash ||
                              e.PeerUserData.blurHash
                        }
                        image_width=""
                      />
                      {e.Records[0].chat_type == "private" &&
                        OnlineUserList.onlineUsers.find(
                          (user) => user.user_id == e.PeerUserData.user_id,
                        ) && (
                          <img
                            className="absolute bottom-0 right-0 z-30 h-4 w-4"
                            src="/Home/Online_Green_dot.png"
                            alt=""
                          />
                        )}
                    </div>
                    {/* <img
                    src={e.is_group ? e.group_profile_image : e.profile_image}
                    className="mr-3 h-10 w-10 rounded-full object-cover 2xl:h-12 2xl:w-12"
                    alt=""
                  /> */}
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <div className="line-clamp-1 min-w-0 flex-1 text-base font-medium capitalize text-darkText">
                          {e.Records[0].chat_type == "group"
                            ? e.Records[0].group_name
                            : e.PeerUserData.user_name}
                        </div>
                        <div className="shrink-0 text-[12px] tabular-nums text-lightText">
                          {chatSidebarTime(
                            e.Records[0].Messages.length > 0
                              ? e.Records[0].Messages[0]?.updatedAt
                              : e.Records[0].updatedAt,
                            { translate: translateTime, hour12 },
                          )}
                        </div>
                      </div>

                      <div className="mt-0.5 flex items-center gap-2">
                        {/* <LiaCheckDoubleSolid className="text-lg text-primary" /> */}
                        <div className="line-clamp-1 flex min-w-0 flex-1 gap-x-1 text-[13px] text-lightText">
                          {/* First check for typing ====================================================================================*/}
                          <>
                            {TypingUserList.typingUserList.some(
                              (typing) =>
                                typing.chat_id == e.Records[0].chat_id,
                            ) ? (
                              <TypingIndicator />
                            ) : (
                              e.Records[0].Messages.length > 0 && (
                                <>
                                  {["image", "gif", "video"].includes(
                                    e.Records[0].Messages[0].message_type ||
                                      "",
                                  ) ? (
                                    <ChatListLastMessagePreview
                                      message={e.Records[0].Messages[0]}
                                    />
                                  ) : e.Records[0].Messages[0].message_type ==
                                    "doc" ? (
                                    <>
                                      <HiOutlineDocumentText className="fa fa-solid fa-image w-5 text-lg text-gray-500" />
                                      <TextTranslate text="Document" />
                                    </>
                                  ) : e.Records[0].Messages[0].message_type ==
                                    "location" ? (
                                    <>
                                      <IoLocationOutline className="fa fa-solid fa-image w-5 text-lg text-gray-500" />
                                      <TextTranslate text="Location" />
                                    </>
                                  ) : e.Records[0].Messages[0].message_type ==
                                    "text" ? (
                                    <span className="line-clamp-1 w-full">
                                      {e.Records[0].Messages[0].message_content}
                                    </span>
                                  ) : e.Records[0].Messages[0].message_type ==
                                    "link" ? (
                                    <>
                                      <span>🔗</span>
                                      <span className="line-clamp-1 w-full">
                                        {
                                          e.Records[0].Messages[0]
                                            .message_content
                                        }
                                      </span>
                                    </>
                                  ) : e.Records[0].Messages[0].message_type ==
                                    "contact" ? (
                                    <div className="flex items-center gap-1">
                                      <RiContactsLine />
                                      <span className="line-clamp-1">
                                        <TextTranslate text="Contact" />
                                      </span>
                                    </div>
                                  ) : e.Records[0].Messages[0].message_type ==
                                      "video" ||
                                    e.Records[0].Messages[0].message_type ==
                                      "audio" ? (
                                    <>
                                      <CallInConversationList messageData={e} />
                                    </>
                                  ) : (
                                    <>
                                      {e.Records[0].Messages[0].message_content}
                                    </>
                                  )}
                                </>
                              )
                            )}
                          </>
                        </div>
                        {e.Records[0].unseen_count > 0 ? (
                          <div className="grid h-5 min-w-5 shrink-0 place-content-center rounded-full bg-themeColor px-1.5 text-[11px] font-semibold tabular-nums leading-none text-white">
                            {e.Records[0].unseen_count}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </ContextMenuTrigger>
              </>
            );
          })
        )}
      </div>

      <ContextMenu id="my-context-menu-2" className="!rounded-xl !bg-modalBg !p-1">
        {(() => {
          const menuItems: ReactElement[] = [
            <ContextMenuItem
              key="unarchive"
              onClick={() => unArchiveConversation()}
              className={chatMenuItemClass}
            >
              <span>
                <TextTranslate text="Unarchive Chat" />
              </span>
              <IoArchiveOutline className="text-xl" />
            </ContextMenuItem>,
            <ContextMenuItem
              key="delete"
              onClick={() => deleteConversation()}
              className={chatMenuItemClass}
            >
              <span>
                <TextTranslate text="Delete Chat" />
              </span>
              <LuTrash2 className="text-xl" />
            </ContextMenuItem>,
          ];
          if (SelectedConversation?.Records[0].chat_type == "private") {
            menuItems.push(
              <ContextMenuItem
                key="block"
                onClick={() => blockUser()}
                className={chatMenuItemClass}
              >
                <span>
                  <TextTranslate
                    text={
                      SelectedConversation?.Records[0].blocked_by.includes(
                        user_id.toString(),
                      )
                        ? "Unblock"
                        : "Block"
                    }
                  />
                </span>
                <MdOutlineBlock className="text-xl" />
              </ContextMenuItem>,
            );
          }
          return menuItems;
        })()}
      </ContextMenu>
    </>
  );
}
